(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["palto-social-carousel"] && !Shopify.designMode) return;
  try {
    
  class PaltoSocialCarousel extends HTMLElement {
    connectedCallback() {
      if (this.track) return;
      this.viewport = this.querySelector('.palto-bts__viewport');
      this.track = this.querySelector('.palto-bts__track');
      this.prevButton = this.querySelector('.palto-bts__arrow--prev');
      this.nextButton = this.querySelector('.palto-bts__arrow--next');
      this.originals = [...this.track.children];
      this.total = this.originals.length;
      this.interval = Number(this.dataset.interval) || 4000;
      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.hovered = false;
      this.focused = false;
      this.pausedUntil = 0;
      this.videos = [];
      this.videoStates = new Map();

      this.prevButton.addEventListener('click', () => this.manual(-1));
      this.nextButton.addEventListener('click', () => this.manual(1));
      this.track.addEventListener('transitionend', (event) => {
        if (event.target === this.track) this.normalize();
      });
      this.addEventListener('pointerenter', (event) => {
        if (event.pointerType === 'mouse') this.hovered = true;
      });
      this.addEventListener('pointerleave', () => (this.hovered = false));
      this.addEventListener('focusin', (event) => {
        this.focused = true;
        this.viewport.scrollLeft = 0;
        this.revealFocused(event.target);
      });
      /* Focusing a card would scroll the clipped viewport on top of the track transform. */
      this.viewport.addEventListener('scroll', () => {
        if (this.viewport.scrollLeft !== 0) this.viewport.scrollLeft = 0;
      });
      this.addEventListener('focusout', (event) => {
        if (!this.contains(event.relatedTarget)) this.focused = false;
      });
      this.setUpSwipe();

      /* Media events do not bubble, so they are caught on the way down. */
      this.track.addEventListener('ended', (event) => this.videoEnded(event.target), true);
      for (const type of ['play', 'pause', 'ended']) {
        this.track.addEventListener(type, (event) => this.showVideoState(event.target), true);
      }
      this.track.addEventListener('click', (event) => {
        const toggle = event.target.closest?.('.palto-bts__video-toggle');
        if (toggle && !event.defaultPrevented) this.toggleVideo(toggle);
      });
      this.onVisibilityChange = () => this.syncVideos();
      document.addEventListener('visibilitychange', this.onVisibilityChange);

      this.resizeObserver = new ResizeObserver(() => this.layout());
      this.resizeObserver.observe(this.viewport);
      this.layout();
      this.restartTimer();
    }

    disconnectedCallback() {
      window.clearInterval(this.timer);
      this.resizeObserver?.disconnect();
      this.videoObserver?.disconnect();
      document.removeEventListener('visibilitychange', this.onVisibilityChange);
    }

    restartTimer() {
      window.clearInterval(this.timer);
      this.timer = window.setInterval(() => this.tick(), this.interval);
    }

    get perView() {
      return Number(getComputedStyle(this).getPropertyValue('--palto-bts-per-view')) || 3;
    }

    /* (Re)builds the clones for the current number of visible cards. */
    layout() {
      const clones = Math.ceil(this.perView);
      const looping = this.total > Math.floor(this.perView);
      if (clones !== this.cloneCount || looping !== this.looping) {
        this.track.querySelectorAll('[data-clone]').forEach((clone) => clone.remove());
        this.cloneCount = looping ? clones : 0;
        this.looping = looping;
        if (looping) {
          const makeClone = (slide) => {
            const clone = slide.cloneNode(true);
            clone.dataset.clone = '';
            clone.removeAttribute('data-shopify-editor-block');
            clone.setAttribute('aria-hidden', 'true');
            clone.inert = true;
            clone.querySelectorAll('a, button').forEach((control) => control.setAttribute('tabindex', '-1'));
            clone.removeAttribute('data-playing');
            clone.querySelectorAll('video').forEach((video) => video.removeAttribute('data-visible'));
            return clone;
          };
          this.originals.slice(-clones).forEach((slide) => this.track.insertBefore(makeClone(slide), this.track.firstChild));
          this.originals.slice(0, clones).forEach((slide) => this.track.appendChild(makeClone(slide)));
        }
        this.index = this.cloneCount;
        this.setUpVideos();
      }
      this.prevButton.hidden = !looping;
      this.nextButton.hidden = !looping;
      this.toggleAttribute('data-static', !looping);
      /* The arrows are centred on the tiles, not on the tiles plus the platform labels below them. */
      const media = this.originals[0].querySelector('.palto-bts__media');
      if (media) this.style.setProperty('--palto-bts-arrow-top', `${media.offsetHeight / 2}px`);
      this.move(false);
    }

    get step() {
      const slide = this.originals[0];
      const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
      return slide.getBoundingClientRect().width + gap;
    }

    move(animate = true, offset = 0) {
      const smooth = animate && !this.reducedMotion.matches;
      this.track.style.transition = smooth ? '' : 'none';
      this.track.style.transform = `translate3d(${-this.index * this.step + offset}px, 0, 0)`;
      if (!smooth) this.normalize();
    }

    /* Jumps from a clone back to the matching original card without animation. */
    normalize() {
      if (!this.looping) return;
      let jumped = false;
      if (this.index >= this.total + this.cloneCount) {
        this.index -= this.total;
        jumped = true;
      } else if (this.index < this.cloneCount) {
        this.index += this.total;
        jumped = true;
      }
      if (jumped) {
        this.track.style.transition = 'none';
        this.track.style.transform = `translate3d(${-this.index * this.step}px, 0, 0)`;
        void this.track.offsetWidth;
        this.track.style.transition = '';
      }
    }

    go(direction) {
      if (!this.looping) return;
      this.normalize();
      this.index += direction;
      this.move(true);
    }

    manual(direction) {
      this.pausedUntil = Date.now() + 8000;
      this.go(direction);
    }

    tick() {
      if (this.reducedMotion.matches || document.hidden || this.hovered || this.focused) return;
      if (Date.now() < this.pausedUntil || this.videoPlaying()) return;
      this.go(1);
    }

    /* Watches every video, clones included; a video counts as visible from 60% on. */
    setUpVideos() {
      this.videos = [...this.track.querySelectorAll('.palto-bts__video')];
      if (!this.videos.length) return;
      this.videoObserver ??= new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) =>
            entry.target.toggleAttribute('data-visible', entry.isIntersecting && entry.intersectionRatio >= 0.6)
          );
          this.syncVideos();
        },
        { threshold: [0, 0.6] }
      );
      this.videoObserver.disconnect();
      this.videos.forEach((video) => {
        video.muted = true;
        this.videoObserver.observe(video);
      });
    }

    videoState(post) {
      if (!this.videoStates.has(post)) {
        this.videoStates.set(post, { element: null, done: false, userPaused: false, userPlayed: false });
      }
      return this.videoStates.get(post);
    }

    videoPlaying() {
      return this.videos.some((video) => video.hasAttribute('data-visible') && !video.paused && !video.ended);
    }

    /*
      Plays the visible copy of each video and pauses everything else. A video plays once per appearance;
      when the loop swaps a clone for its original, playback continues on the copy now in view.
    */
    syncVideos() {
      const posts = new Map();
      this.videos.forEach((video) => {
        if (!posts.has(video.dataset.post)) posts.set(video.dataset.post, []);
        posts.get(video.dataset.post).push(video);
      });
      posts.forEach((videos, post) => {
        const state = this.videoState(post);
        const shown = videos.find((video) => video.hasAttribute('data-visible'));
        videos.forEach((video) => {
          if (video !== shown && !video.paused) video.pause();
        });
        if (!shown) {
          state.element = null;
          state.done = false;
          state.userPlayed = false;
          return;
        }
        if (state.element && state.element !== shown && state.element.currentTime > 0) {
          shown.currentTime = state.element.currentTime;
        }
        state.element = shown;
        const autoplay = state.userPlayed || !this.reducedMotion.matches;
        const wanted = autoplay && !document.hidden && !state.done && !state.userPaused;
        if (wanted && shown.paused) shown.play().catch(() => {});
        else if (!wanted && !shown.paused) shown.pause();
      });
    }

    videoEnded(video) {
      const state = this.videoState(video.dataset.post);
      state.done = true;
      state.userPlayed = false;
      video.currentTime = 0;
      this.restartTimer();
      if (!this.videoPlaying()) this.tick();
    }

    toggleVideo(button) {
      const video = button.closest('.palto-bts__slide')?.querySelector('.palto-bts__video');
      if (!video) return;
      const state = this.videoState(video.dataset.post);
      if (video.paused) {
        Object.assign(state, { done: false, userPaused: false, userPlayed: true });
        this.revealFocused(button);
      } else {
        Object.assign(state, { userPaused: true, userPlayed: false });
      }
      this.syncVideos();
    }

    showVideoState(video) {
      const slide = video.closest('.palto-bts__slide');
      const playing = !video.paused && !video.ended;
      slide.toggleAttribute('data-playing', playing);
      slide.querySelector('.palto-bts__video-toggle')?.setAttribute('aria-label', playing ? 'Video pausieren' : 'Video abspielen');
    }

    /* Keeps a card that receives keyboard focus fully in view. */
    revealFocused(target) {
      const slide = target.closest?.('.palto-bts__slide');
      const position = this.originals.indexOf(slide);
      if (!this.looping || position < 0) return;
      const first = this.index - this.cloneCount;
      const visible = Math.floor(this.perView);
      const relative = (((position - first) % this.total) + this.total) % this.total;
      if (relative < visible) return;
      this.index = this.cloneCount + position;
      this.move(true);
    }

    /* Touch uses touch events (pointer events get cancelled by the browser's own panning); mouse drags use pointer events. */
    setUpSwipe() {
      let startX = 0;
      let startY = 0;
      let deltaX = 0;
      let dragging = false;
      let moved = false;
      let vertical = false;
      const start = (x, y) => {
        if (!this.looping) return;
        dragging = true;
        moved = false;
        vertical = false;
        startX = x;
        startY = y;
        deltaX = 0;
        this.normalize();
      };
      const drag = (x, y) => {
        if (!dragging || vertical) return false;
        deltaX = x - startX;
        if (!moved) {
          if (Math.abs(y - startY) > 10 && Math.abs(y - startY) > Math.abs(deltaX)) {
            vertical = true;
            return false;
          }
          if (Math.abs(deltaX) > 8) moved = true;
        }
        if (moved) this.move(false, deltaX);
        return moved;
      };
      const end = () => {
        if (!dragging) return;
        dragging = false;
        if (!moved) return;
        this.pausedUntil = Date.now() + 8000;
        const threshold = Math.min(60, this.step / 4);
        if (deltaX <= -threshold) this.index += Math.max(1, Math.round(-deltaX / this.step));
        else if (deltaX >= threshold) this.index -= Math.max(1, Math.round(deltaX / this.step));
        this.move(true);
      };
      this.viewport.addEventListener('touchstart', (event) => start(event.touches[0].clientX, event.touches[0].clientY), { passive: true });
      this.viewport.addEventListener(
        'touchmove',
        (event) => {
          if (drag(event.touches[0].clientX, event.touches[0].clientY) && event.cancelable) event.preventDefault();
        },
        { passive: false }
      );
      this.viewport.addEventListener('touchend', end);
      this.viewport.addEventListener('touchcancel', end);
      this.viewport.addEventListener('pointerdown', (event) => {
        if (event.pointerType === 'mouse' && event.button === 0) start(event.clientX, event.clientY);
      });
      this.viewport.addEventListener('pointermove', (event) => {
        if (event.pointerType === 'mouse' && drag(event.clientX, event.clientY)) this.viewport.setPointerCapture?.(event.pointerId);
      });
      this.viewport.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse') end();
      });
      /* A swipe must not also open the post. */
      this.viewport.addEventListener(
        'click',
        (event) => {
          if (moved) {
            event.preventDefault();
            moved = false;
          }
        },
        true
      );
    }
  }

  if (!customElements.get('palto-social-carousel')) {
    customElements.define('palto-social-carousel', PaltoSocialCarousel);
  }

  } catch(e) { console.error(e); }
})();
})();
